<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			
			<b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Upload Purchase Request Detail" active>
                                <b-row v-if="hasFailedDataFinishGoodQcConfirmationDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedFinishGoodQcConfirmationDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQcConfirmationDetailsFailed" :fields="fieldsFinishGoodQcConfirmationDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedFinishGoodQcConfirmationDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="finishGoodQcConfirmationDetails" :fields="fieldsFinishGoodQcConfirmationDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 

import FinishGoodQcConfirmationDetail from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetail';
import FinishGoodQcConfirmationDetailFilter from '@/filters/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailFilter';

import { saveAs } from 'file-saver';
import AppInputFileupload from '@/components/AppInputFileupload';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
			return {
				fileupload: null,
				uploadProcessId: null,
				datas: Array(),
				fieldsFinishGoodQcConfirmationDetail: [
					// {"no" : { "class" : "th-number"}},
					{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
					{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
					{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
					{"class" : "th-status", "label" : "FinishGoodQcConfirmation", key: 'finishGoodQcConfirmationRequestNumber', sortable: false},
					{"class" : "th-status", "label" : "Finish Good Quality Inspection", key: 'finishGoodQualityInspectionControlCard', sortable: false},
					{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
					{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},

					{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
					{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
					{"actions": { "class" : "th-actions", "label" : "" }}
				],
				selectAll:false,
				sortBy: '',
				sortDesc: '',
				busy:false,
				isDataLoading: false,
				isBusy : false,
				selected:'',
				pageSizeOptions: 10,
				pageIndex:0,
				sortingBy: Array(),
				processId: "",
				finishGoodQcConfirmationDetails : [],
				finishGoodQcConfirmationDetailsFailed: [],
				hasFailedDataFinishGoodQcConfirmationDetail: false,
				totalFailedFinishGoodQcConfirmationDetail: 0,
				totalSucceedFinishGoodQcConfirmationDetail: 0,
				isUploadSuccess: false,
			}
		},	methods : {
			resetModal() {
				this.datas = Array();
				this.isUploadSuccess = false;
				this.$emit('resetMethod', 'FinishGoodQcConfirmationDetail');
			},
			uploadButtonAction(modalEvent) {
				modalEvent.preventDefault();
				let _this = this;
				_this.isBusy = true;
				if(this.isUploadSuccess) {
					this.$http.post('finishgoodqcconfirmationdetail/confirmUpload/' + _this.uploadProcessId + '/' + _this.parentId,
						[],
						).then(async function(response){
							if (response != null) {
								if (response.data != null) {
									_this.resetModal();
									_this.datas = Array();
									_this.fileupload = null;
									_this.isUploadSuccess = false;
								}
							}
							_this.isBusy = false;
						})
						.catch(error => {
							_this.$store.dispatch('addErrorMessageGlobal', error);
							_this.isBusy = false;
						});
				} else {
					console.log("parentId", _this.parentId);
					if (this.fileupload != null) {
						let data = new FormData();
						data.append('file', this.fileupload);
						this.$http.post(process.env.VUE_APP_API_URL + 'finishgoodqcconfirmationdetail/upload',
							data,
							{ headers: { 'Content-Type': 'multipart/form-data' } }
							).then(async function(response){
								_this.uploadProcessId = response.data.id;
								_this.isUploadSuccess = true;
								await _this.getFinishGoodQcConfirmationDetailForUpload();
								_this.isBusy = false;
								console.log("this.isBusy success", _this.isBusy);
							})
							.catch(error => {
								this.$store.dispatch('addErrorMessageGlobal', error);
								_this.isBusy = false;
								console.log("this.isBusy error", _this.isBusy);
							});
					}
				}
			},
			getFinishGoodQcConfirmationDetailForUpload : async function() {
				let _this = this;
				this.$http.get('finishGoodQcConfirmationDetail/uploadresult/' + _this.uploadProcessId)
					.then(async function(response) {
						_this.finishGoodQcConfirmationDetails = [];


						if (response != null) {
							let result = response.data;
							_this.finishGoodQcConfirmationDetails = result.filter(o => { return o.uploadValidationStatus == "Success"});
							_this.totalSucceedFinishGoodQcConfirmationDetail = _this.finishGoodQcConfirmationDetails.length;

							_this.finishGoodQcConfirmationDetailsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
							_this.hasFailedDataFinishGoodQcConfirmationDetail = true;
							_this.totalFailedFinishGoodQcConfirmationDetail = 0;
							if(_this.finishGoodQcConfirmationDetailsFailed == undefined || _this.finishGoodQcConfirmationDetailsFailed.length === 0) _this.hasFailedDataFinishGoodQcConfirmationDetail = false;
							if(_this.hasFailedDataFinishGoodQcConfirmationDetail) _this.totalFailedFinishGoodQcConfirmationDetail = _this.finishGoodQcConfirmationDetailsFailed.length;

							_this.isBusy = false;
						}
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			},
			downloadLog() {
				let _this = this;
				let url = 'finishgoodqcconfirmationdetail/downloadlog/' + _this.uploadProcessId;
				this.$http.get(url, {responseType: 'blob'}).then(async response => {
					if (response != null) {
						await saveAs(response.data, 'FinishGoodQcConfirmationDetail.xlsx');
					}
				}).catch(error => {
					this.$store.dispatch('addErrorMessageGlobal', error);
					throw error;
				});
			}
		},	beforeMount() {
	},
	mounted(){
	},
	computed: {
		okTitle: {
			get: function() {
			if (this.datas != null) {
				if (this.datas.length > 0) {
				return "Proses";
				}
			}
			return "Simpan";
			}
		},
		isShowPopup : {
			get: function () {
			if (this.openPopup) return true;
			else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
